export default "__VITE_ASSET__DRobSLVj__"